(function () {
  'use strict';

  function clean(value) {
    return String(value || '').trim();
  }

  function normText(value) {
    return clean(value)
      .replace(/×/g, 'x')
      .replace(/[，,]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normMaterial(value) {
    var s = normText(value).toUpperCase();
    if (/\bSILICONE\b/.test(s)) return 'SILICONE';
    if (/\bFFKM\b/.test(s)) return 'FFKM';
    if (/\bFKM\b|\bVITON\b|\bFPM\b/.test(s)) return 'FKM';
    if (/\bEPDM\b/.test(s)) return 'EPDM';
    if (/\bNBR\b|\bBUNA\b/.test(s)) return 'NBR';
    return '';
  }

  function normHardness(value) {
    var s = normText(value).toUpperCase();
    var m = s.match(/\b(60|70|75|80|90)\s*(?:A|SHORE\s*A|SHA)?\b/);
    return m ? m[1] : '';
  }

  function fmt2(value) {
    var n = parseFloat(value);
    if (!isFinite(n)) return '';
    return n.toFixed(2);
  }

  function quoteUrl(spec) {
    var p = new URLSearchParams();
    if (spec.id) p.set('id', spec.id);
    if (spec.cs) p.set('cs', spec.cs);
    if (spec.material) p.set('material', spec.material);
    if (spec.hardness) p.set('hardness', spec.hardness + 'A');
    p.set('source', 'fullspec_exact_resolver');
    return '/pages/bulk-quote?' + p.toString();
  }

  function parseFullSpec(query) {
    var raw = normText(query);
    if (!raw) return null;

    // Explicit inch full-spec in top search:
    // 0.124 x 0.071 inch EPDM 70A -> 3.15 x 1.80 EPDM 70A
    var hasInch = /\b(in|inch|inches)\b|"/i.test(raw);

    var sizeMatch = raw.match(/(\d+(?:\.\d+)?)\s*(?:x|\*)\s*(\d+(?:\.\d+)?)(.*)$/i);
    if (!sizeMatch) return null;

    var id = parseFloat(sizeMatch[1]);
    var cs = parseFloat(sizeMatch[2]);
    if (!isFinite(id) || !isFinite(cs)) return null;

    if (hasInch) {
      id = id * 25.4;
      cs = cs * 25.4;
    }

    var tail = normText(sizeMatch[3] || '');
    var material = normMaterial(tail || raw);
    var hardness = normHardness(tail || raw);

    if (!material || !hardness) return null;

    return {
      id: fmt2(id),
      cs: fmt2(cs),
      material: material,
      hardness: hardness
    };
  }

  function parseFinderForm(form) {
    if (!form || !form.querySelector) return null;

    var idEl = form.querySelector('[data-field="id"], input[name*="id" i], input[placeholder*="Inner" i]');
    var csEl = form.querySelector('[data-field="cs"], input[name*="cs" i], input[placeholder*="Cross" i]');
    var matEl = form.querySelector('[data-field="material"], select[name*="material" i], input[name*="material" i]');
    var hardEl = form.querySelector('[data-field="hardness"], select[name*="hardness" i], input[name*="hardness" i]');

    var id = idEl ? clean(idEl.value) : '';
    var cs = csEl ? clean(csEl.value) : '';
    var material = matEl ? normMaterial(matEl.value) : '';
    var hardness = hardEl ? normHardness(hardEl.value) : '';

    if (!id || !cs || !material || !hardness) return null;

    return {
      id: fmt2(id),
      cs: fmt2(cs),
      material: material,
      hardness: hardness
    };
  }

  function lookup(spec) {
    if (!spec || !window.oxxFinderLookup) return '';
    // Try normalized material first.
    var h = window.oxxFinderLookup(spec.id, spec.cs, spec.material, spec.hardness);
    if (h) return h;

    // Some old indexes may use display material case.
    var materialDisplay = spec.material === 'SILICONE' ? 'Silicone' : spec.material;
    h = window.oxxFinderLookup(spec.id, spec.cs, materialDisplay, spec.hardness);
    if (h) return h;

    // Last fallback: direct key if full index object exists in either known shape.
    var key = spec.id + '|' + spec.cs + '|' + spec.material + '|' + spec.hardness;
    try {
      if (window.OXX_FINDER_INDEX && window.OXX_FINDER_INDEX.exact && window.OXX_FINDER_INDEX.exact[key]) {
        return window.OXX_FINDER_INDEX.exact[key];
      }
      if (window.oxxFinderIndex && window.oxxFinderIndex.exact && window.oxxFinderIndex.exact[key]) {
        return window.oxxFinderIndex.exact[key];
      }
    } catch (e) {}

    return '';
  }

  function routeFullSpec(spec) {
    var handle = lookup(spec);
    if (handle) {
      window.location.href = '/products/' + handle;
      return true;
    }

    window.location.href = quoteUrl(spec);
    return true;
  }

  function maybeHandleSearchInput(value) {
    var spec = parseFullSpec(value);
    if (!spec) return false;
    return routeFullSpec(spec);
  }

  function shouldHandleFinderForm(form) {
    if (!form) return false;
    var id = form.id || '';
    var cls = form.className || '';
    var text = (id + ' ' + cls + ' ' + (form.getAttribute('action') || '')).toLowerCase();

    if (text.indexOf('finder') !== -1) return true;
    if (text.indexOf('quick') !== -1) return true;
    if (form.querySelector('[data-field="id"]') && form.querySelector('[data-field="cs"]')) return true;

    return false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;

    // Homepage Finder / Collection Quick Filter full four fields.
    if (shouldHandleFinderForm(form)) {
      var spec = parseFinderForm(form);
      if (spec) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        routeFullSpec(spec);
        return;
      }
    }

    // Header/top search full spec typed into search field.
    var action = form.getAttribute('action') || '';
    var role = form.getAttribute('role') || '';
    var input = form.querySelector('input[name="q"], input[type="search"], .search__input');
    if (!input) return;
    if (action.indexOf('/search') === -1 && role !== 'search') return;

    var spec2 = parseFullSpec(input.value);
    if (!spec2) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    routeFullSpec(spec2);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    var input = event.target;
    if (!input || !input.matches) return;
    if (!input.matches('input[name="q"], input[type="search"], .search__input')) return;

    var spec = parseFullSpec(input.value);
    if (!spec) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    routeFullSpec(spec);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('button, a, .search__button, .predictive-search__search-for-button button') : null;
    if (!button) return;

    var form = button.closest ? button.closest('form') : null;
    var input = null;

    if (form) input = form.querySelector('input[name="q"], input[type="search"], .search__input');
    if (!input) input = document.querySelector('input[name="q"]:focus, input[type="search"]:focus, .search__input:focus');
    if (!input) return;

    var spec = parseFullSpec(input.value);
    if (!spec) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    routeFullSpec(spec);
  }, true);

  /* OxxRing launch cleanup: capture homepage Finder / Quick Filter click fallback.
     This only handles full four-field specs and leaves partial search/filter behavior unchanged. */
  function parseHomepageFinderSpec() {
    var idEl = document.getElementById('id-in');
    var csEl = document.getElementById('cs-in');
    var matEl = document.getElementById('mat-select');
    var hardEl = document.getElementById('hard-select');
    if (!idEl || !csEl || !matEl || !hardEl) return null;
    var unitEl = document.getElementById('i-unit');
    var id = clean(idEl.value);
    var cs = clean(csEl.value);
    var material = normMaterial(matEl.value);
    var hardness = normHardness(hardEl.value);
    if (!id || !cs || !material || !hardness) return null;
    var idNum = parseFloat(id);
    var csNum = parseFloat(cs);
    if (!isFinite(idNum) || !isFinite(csNum)) return null;
    if (unitEl && unitEl.checked) {
      idNum = idNum * 25.4;
      csNum = csNum * 25.4;
    }
    return { id: fmt2(idNum), cs: fmt2(csNum), material: material, hardness: hardness };
  }

  function parseFullSpecFromScope(scope) {
    if (!scope || !scope.querySelector) return null;
    var idEl = scope.querySelector('[data-field="id"]');
    var csEl = scope.querySelector('[data-field="cs"]');
    var matEl = scope.querySelector('[data-field="material"]');
    var hardEl = scope.querySelector('[data-field="hardness"]');
    if (!idEl || !csEl || !matEl || !hardEl) return null;
    var id = clean(idEl.value);
    var cs = clean(csEl.value);
    var material = normMaterial(matEl.value);
    var hardness = normHardness(hardEl.value);
    if (!id || !cs || !material || !hardness) return null;
    return { id: fmt2(id), cs: fmt2(cs), material: material, hardness: hardness };
  }

  function routeFullSpecAfterLookup(spec) {
    if (!spec) return false;
    routeFullSpec(spec);
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest('#search-btn, button[type="submit"], .oxx-static-finder__apply, .oxx-context-finder__submit') : null;
    if (!trigger) return;

    var spec = null;
    if (trigger.id === 'search-btn') {
      spec = parseHomepageFinderSpec();
    }
    if (!spec) {
      var form = trigger.closest ? trigger.closest('form') : null;
      spec = parseFullSpecFromScope(form);
    }
    if (!spec) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    routeFullSpecAfterLookup(spec);
  }, true);

})();